import React from "react";
import { Wrapper, Content, Overlay, HeroButton, AnimatedBackground } from "./Banner.styles";
import heroBg from "../../images/hero_bg.webp";

const Banners = () => (
    <Wrapper id="home">
        <AnimatedBackground bgImage={heroBg} />
        <Overlay />
        <Content>
            <div className="heroCopy">
              <h1>JINDAL GROUP</h1>
              <h2>Powering Progress Since 1965</h2>
              <p className="category">Tyres • Petroleum • Transportation • Retail</p>
              <p className="description">Industrial excellence across multiple business divisions serving Central India with integrity and operational strength.</p>
              <div className="trustIndicators">
                <span>Established 1965</span>
                <span>60+ Years Legacy</span>
                <span>Multi-Division Enterprise</span>
                <span>Central India Leader</span>
              </div>
            </div>
            <HeroButton href="#businesses">Explore Our Businesses</HeroButton>
        </Content>
    </Wrapper>
);

export default Banners;